import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { makeStyles } from 'design-system/styles';
import { getAnnotationId } from '@scale/frontend-lib/annotation';
import { Annotation } from '@scale/shared/types/annotation';

/*
 * Displayed inline in the annotations list
 */

const LinkedAnnotationRow = (props: {
  isEditableMode: boolean;
  selectedAnnotation?: { color: string } & Annotation;
  handleOpen: () => void;
  handleLinkedAttributeClick: (a: Annotation) => void;
}) => {
  const { isEditableMode, selectedAnnotation, handleOpen, handleLinkedAttributeClick } = props;

  const handleSelectedAnnotationClick = () =>
    selectedAnnotation ? handleLinkedAttributeClick(selectedAnnotation) : undefined;

  const classes = makeStyles(theme => ({
    wrapper: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    placeholder: {
      height: '16px',
      margin: '4px',
      display: 'flex',
      alignItems: 'center',
      opacity: 0.5,
    },
    annotation: {
      flexGrow: 1,
      padding: '4px',
      borderRadius: '4px',
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      '&:hover': {
        background: theme.colors.gray05,
      },
    },
    icon: {
      flexGrow: 0,
      flexShrink: 0,
      marginRight: '8px',
      width: '16px',
      height: '16px',
      borderRadius: '4px',
    },
    label: {
      fontWeight: 500,
    },
    id: {
      fontWeight: 400,
      fontFamily: 'monospace',
    },
    edit: {
      marginLeft: '8px',
      cursor: 'pointer',
    },
  }))();

  return (
    <div className={classes.wrapper}>
      {selectedAnnotation && (
        <div className={classes.annotation} onClick={handleSelectedAnnotationClick}>
          <div className={classes.icon} style={{ background: selectedAnnotation.color }} />
          <div className={classes.label}>
            {selectedAnnotation.label}{' '}
            <span className={classes.id}>{getAnnotationId(selectedAnnotation).slice(-4)}</span>
          </div>
        </div>
      )}

      {!selectedAnnotation && <div className={classes.placeholder}>None selected</div>}

      {isEditableMode && (
        <div className={classes.edit} onClick={handleOpen}>
          <FontAwesomeIcon icon="pencil" />
        </div>
      )}
    </div>
  );
};

export default LinkedAnnotationRow;
